module.exports = __webpack_public_path__ + "src/asset/svg/title/blog2.svg?09255f44df3e37ba411787fe7a2cbf9e";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/title/blog2.svg
// module id = 95
// module chunks = 0